<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Pick Detail Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid">List</vs-button>
      <p class="pr-4"></p>
      <!-- <vs-button color="success" type="filled" icon="add" @click="cusAdd">Add</vs-button>
      <p class="pr-4"></p>-->
      <!-- <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="unarchive"
          color="warning"
          v-if="btndis"
        >Picking To Pallet</vs-button>

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPallet">To Pallet</vs-dropdown-item>
          <vs-dropdown-item @click="goAllPallet">All To Pallet</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p> -->
      <vs-button
        color="success"
        type="filled"
        icon="create"
        @click="onCnSubmit"
        v-if="btndis"
      >Confirm Pick</vs-button>
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="print"
          color="#5b3cc4"
          v-if="btndis"
          >Print</vs-button
        >
        <!-- <a href="#">Hola mundo</a> -->

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPrint">PickOrder</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

    </div>
    <inberror v-if="errorshow" key="errorshow" :errdata="errdata"></inberror>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <!-- <palldadd v-if="addshow" :key="addshow" :acstate="acstate" :recid="recid" @grid="grid"></palldadd> -->
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>

    </transition-group>

    <modal name="allModal" :width="400" :height="200" @before-close="beforeModalClose">
      <div class="p-2 hedd">Pallet Number</div>
      <div class="vx-row p-4">
              
        <div class="vx-col w-4/5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Pallet</span>
              </div>
            </template>
            <vs-select autocomplete v-model="allpallet" class="w-full">
              <vs-select-item
                v-for="pallet in pallets"
                :key="pallet.code"
                :value="pallet.code"
                :text="pallet.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row pl-4 -pt-2">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSavePalletAll">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="onResetPallet">Reset</vs-button>
        </div>
      </div>
    </modal>

    <modal name="oneModal" :width="400" :height="200" @before-close="beforeModalClose">
      <div class="p-2 hedd">Pallet Number</div>
      <div class="vx-row p-4">
              
        <div class="vx-col w-4/5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Pallet</span>
              </div>
            </template>
            <vs-select autocomplete v-model="onepallet" class="w-full">
              <vs-select-item
                v-for="pallet in pallets"
                :key="pallet.code"
                :value="pallet.code"
                :text="pallet.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row pl-4 -pt-2">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSavePallet">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="onResetPallet">Reset</vs-button>
        </div>
      </div>
    </modal>


  </div>
</template>

<script>
import aggrid from "./grid.vue";
import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import inberror from "./inberror";

export default {
  data() {
    return {
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      errordata:null,
      errorshow:false,
      pallets:[],
      onepallet: null,
      allpallet: null,
      pickOrdersNumber: this.$route.params.id,
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      pickdetails: null,
      fabact: [
        // { act: "cusAdd", label: "Add" },
        { act: "onCnSubmit", label: "Confirm Pick" },
        { act: "onPickRemove", label: "Delete Pick" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.exbordersNumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbdetailsSkuscode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text:
              this.formatnumber(item.itempck) +
              "/" +
              this.formatnumber(item.totalpck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.packagesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.locationsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.cvDate(item.createdAt),
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.tmotypesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    async goPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.pickOrdersNumber,
            editor: this.userid
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/picks/picksPrint`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArray(response.data.pickDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",

              footer: (currentPage, pageCount) => {
                return {
                  columns: [
                    {
                      text: [
                        {
                          text:
                            "ผู้จัดทำเอกสาร " +
                            response.data.pickDetails[0].editor +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },

                        {
                          text:
                            "ผู้ส่งมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "ผู้รับมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "พิมพ์ ณ วันที่ " + this.cvDate(new Date()) + "\n",
                          fontSize: 14,
                        },
                        {
                          text:
                            "Page " +
                            currentPage.toString() +
                            " / " +
                            pageCount +
                            "\t\t",
                        },
                      ],
                      alignment: "center",
                    },
                  ],
                };
              },

              content: [
                {
                  text: "ใบสั่งการนำสินค้าออกจากคลังสินค้า",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบนำสินค้าออกเลขที่ " + response.data.picksNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Outbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "UNIT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Location",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Order Pick At",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Type",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {},{}, {}, {}, {},{}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60, 60, 60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {
                          text: "Total Packages",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: this.formatnumber(response.data.sumpck),
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {},
                        {},
                        {},
                        {},
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
      this.pickdetails = val;
    },
    // cusAdd() {
    //   this.recid = 0;
    //   this.addshow = true;
    //   this.gridshow = false;
    //   this.btndis = false;
    //   this.acstate = "ADD";
    // },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    regrid() {
      // this.$router.replace("/Skus/0");
      this.masrec = "0";
      this.gridshow = false;
      this.errorshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    goPallet() {
      this.$modal.show("oneModal");
    },
    goAllPallet() {
      this.$modal.show("allModal");
    },
    onResetPallet(){
      this.allpallet="";
      this.onepallet="";
    },
    onSavePalletAll() {
      this.$modal.hide("allModal");
      // console.log(this.pickOrdersNumber);
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        pickdetails: this.pickdetails,
        new_pallets_code: this.allpallet,
      };
      axios
        .post("/ApiPickSavePalletAll", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Put to Pallet Error",
              text: res.data.message,
              fixed: true,
            });
          } else {
            this.$store.dispatch("setReportGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Put to Pallet Complete",
              text: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "PutAway Error",
            text: err,
          });
        });
    },
    onSavePallet() {
      this.$modal.hide("oneModal");
      // console.log(this.recid);
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        pickdetails: this.pickdetails,
        new_pallets_code: this.onepallet,
      };
      axios
        .post("/ApiPickSavePallet", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Put to Pallet Error",
              text: res.data.message,
              fixed: true,
            });
          } else {
            this.$store.dispatch("setPickDetailsGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Put to Pallet Complete",
              text: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "PutAway Error",
            text: err,
          });
        });
    },
    beforeModalClose(){

    },
    onCnSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Confirm Pick? ",
        accept: this.onCnPickSubmit,
      });
    },
    async onCnPickSubmit() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.pickdetails,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/cnPick`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "cnpick Complete",
              text: response.data.message,
            });

            this.pickOrdersNumber = response.data.picknum;

            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            localStorage.setItem("LS_Page", this.$route.path);
            this.$router.replace("/ships");
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    onPickRemove() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Remove PickDetails? ",
        accept: this.onCPickRemove,
      });
    },
    onCPickRemove() {
      // console.log(this.locations_code);
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        pickOrdersNumber: this.pickOrdersNumber,
      };
      axios
        .post("/ApiPaldDel", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "PutAway Error",
              text: res.data.message,
              fixed: true,
            });
          } else {
            this.$store.dispatch("setPickDetailsGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Remove Complete",
              text: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "PutAway Error",
            text: err,
          });
        });
    },

    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
    inberror,
  },
  created() {
    this.checkProfiles();
    // console.log(this.inborders_number);
    this.masrec = this.pickOrdersNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
       
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
.hedd {
  font-weight: bold;
}
</style>
